<template>
  <v-container flat fluid>
    <v-card>
      <v-card-title class="primary white--text">
        <span class="title">Documents</span>
        <v-spacer></v-spacer>
        <v-btn
          fab
          x-small
          color="blue"
          @click="newDocument"
          :disabled="!canAddDocument"
          :dark="canAddDocument"
        >
          <font-awesome-icon size="lg" icon="plus" />
        </v-btn>
      </v-card-title>
      <v-form>
        <v-container flat fluid>
          <v-row v-for="(item, index) in obj.documents" :key="index" no-gutters>
            <v-col>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="item.type"
                    label="Document"
                    outlined
                    filled
                    hide-details
                    autocomplete="off"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6" v-if="!template && !item.filename">
                  <v-file-input
                    show-size
                    accept="image/*, .pdf"
                    label="File input"
                    v-model="item.value"
                    hide-details
                    outlined
                    filled
                  ></v-file-input>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  v-if="!template && item.createdAt && item.filename"
                  align-self="center"
                >
                  <v-btn @click="getFile(item)" class="ml-2">
                    <font-awesome-icon class="mr-2" size="2x" icon="file" />OPEN
                  </v-btn>
                </v-col>
                <v-col cols="2">
                  <v-checkbox :readonly="!template" v-model="item.required" label="Required"></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col style="max-width:25px;" align-self="center" v-if="template || !item.required">
              <v-icon @click="removeDocument(index)" class>mdi-minus-circle</v-icon>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: {
    obj: Object,
    template: Boolean
  },
  data() {
    return {};
  },
  computed: {
    canAddDocument() {
      return this.template
        ? this.canAddToArray(this.obj.documents, ["type"])
        : this.canAddToArray(this.obj.documents, ["value", "type"]) ||
            this.canAddToArray(this.obj.documents, ["filename", "type"]);
    }
  },
  methods: {
    ...mapActions({
      getURL: "documents/getURL"
    }),
    checkForData() {
      if (!this.obj.documents) {
        this.$set(this.obj, "documents", []);
        this.newDocument();
      }
    },
    newDocument() {
      this.template
        ? this.obj.documents.push({
            type: null,
            required: false
          })
        : this.obj.documents.push({
            type: null,
            value: null
          });
    },
    removeDocument(index) {
      this.obj.documents.splice(index, 1);
    },
    async getFile(doc) {
      var url = await this.getURL(doc.filename);
      if (url) {
        window.open(url, "_blank");
      }
    }
  },
  mounted() {
    this.checkForData();
  }
};
</script>
